export function getLocalStorageObject(key: string) {
  if (typeof window !== 'undefined') {
    const storedString = window.localStorage.getItem(key);
    if (storedString) {
      try {
        return JSON.parse(storedString);
      } catch (error) {
        console.error('Error parsing localStorage item:', error);
      }
    }
  }
  return null;
}

export function setLocalStorageObject(key: string, value: { [key: string]: any }) {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(key, JSON.stringify(value));
  }
}

export function updateLocalStorageObject(key: string, value: { [key: string]: any }) {
  if (typeof window !== 'undefined') {
    const updatedAt = Date.now();
    const existingData = getLocalStorageObject(key);
    const newData = { ...existingData, ...value, updatedAt };
    setLocalStorageObject(key, newData);
  }
}

export function removeLocalStorageItem(key: string) {
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(key);
  }
}
